module.exports = __webpack_public_path__ + "img/mainPicture.3543632c.png";